import { render, staticRenderFns } from "./DefaultCard.vue?vue&type=template&id=13671437&scoped=true"
import script from "./DefaultCard.vue?vue&type=script&lang=ts"
export * from "./DefaultCard.vue?vue&type=script&lang=ts"
import style0 from "./DefaultCard.vue?vue&type=style&index=0&id=13671437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13671437",
  null
  
)

export default component.exports